import { render } from "./BrandFilterBody.vue?vue&type=template&id=376b3e33"
import script from "./BrandFilterBody.vue?vue&type=script&lang=js"
export * from "./BrandFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__